module.exports = __webpack_public_path__ + "img/logo-nav-dark.fbbd67e2.png";